import {
  IonButton,
  IonCheckbox,
  IonContent,
  IonInput,
  IonPage,
  useIonAlert,
  useIonLoading,
  useIonPicker,
  useIonToast,
  useIonViewWillEnter,
} from '@ionic/react'
import { checkbox, warning } from 'ionicons/icons'
import { useContext, useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { VALIDATE_STATUS } from '../../../common'
import { CustomSpacer, FooterButtons, StyleIonHeader, TextStyle } from '../../../components'
import { DivideLine, DivideLineBold } from '../../../components/atoms/divide'
import { StoresContext } from '../../../provider/StoreProvider'
import { observer } from 'mobx-react'
import moment from 'moment'
import { validateInput } from '../../../common/utils/validatorUtil'

export const SignUp: React.FC<RouteComponentProps> = observer(({ history }) => {
  const { authStore, commonStore } = useContext(StoresContext)
  const [presentToast] = useIonToast()
  const [present] = useIonPicker()
  const [presentAlert] = useIonAlert()
  const [presentLoading, dismissLoading] = useIonLoading()

  const [name, setName] = useState<string>('')
  const [birthday, setBirthday] = useState<string>('')
  const [nickname, setNickname] = useState<string>('')
  const [zipcode, setZipcode] = useState<string>('')
  const [address, setAddress] = useState<string>('')
  const [addressDetail, setAddressDetail] = useState<string>('')
  const [walletAddress, setWalletAddress] = useState<string>('')
  const [walletName, setWalletName] = useState<string>('')
  const [account, setAccount] = useState<string>('')
  const [bankName, setBankName] = useState<string>('')
  const [bankOwner, setBankOwner] = useState<string>('')
  const [receiptPhoneNumber, setReceiptPhoneNumber] = useState<string>('')

  useIonViewWillEnter(() => {
    commonStore.setShowTab(false)
    authStore.getUserInfo()
  })

  useEffect(() => {
    setName(authStore.userInfo?.name || '')
    setBirthday(
      authStore.userInfo?.birthday == null ? '' : moment(authStore.userInfo?.birthday).format('YYYYMMDD') || '',
    )
    setNickname(authStore.userInfo?.nickname || '')
    setZipcode(authStore.userInfo?.zipcode || '')
    setAddress(authStore.userInfo?.address || '')
    setAddressDetail(authStore.userInfo?.addressDetail || '')
    setWalletAddress(authStore.userInfo?.activeWallet?.address || '')
    setWalletName(authStore.userInfo?.activeWallet?.name || '')
    setAccount(authStore.userInfo?.activeWithdrawalAccount?.account || '')
    setBankName(authStore.userInfo?.activeWithdrawalAccount?.bankName || '')
    setBankOwner(authStore.userInfo?.activeWithdrawalAccount?.bankOwner || '')
    setReceiptPhoneNumber(authStore.userInfo?.extraData?.receiptPhoneNumber || '')
  }, [authStore.userInfo])

  /* checkbox state 관리 */
  const [checkedTerms, setCheckedTerms] = useState({ termsService: false, termsCredit: false, termsMarketing: false })

  const onSelectAll = (event: { target: { checked: boolean } }) => {
    const { checked } = event.target
    const newCheckedItems = Object.keys(checkedTerms).reduce(
      (newCheckedItems, key) => ({
        ...newCheckedItems,
        [key]: checked,
      }),
      { termsService: true, termsCredit: true, termsMarketing: true },
    )
    setCheckedTerms(newCheckedItems)
  }

  const onCheckChange = (event: { target: { name: string; checked: boolean } }) => {
    const name = event.target.name
    setCheckedTerms({
      ...checkedTerms,
      [name]: event.target.checked,
    })
  }

  /* validate */
  const [validateStatus, setValidateStatus] = useState<VALIDATE_STATUS>(VALIDATE_STATUS.INPUT)

  const [nameCheck, setNameCheck] = useState<boolean>(false)
  const [birthdayCheck, setBirthdayCheck] = useState<boolean>(false)
  const [nickCheck, setNickCheck] = useState<boolean>(false)
  const [bankAccountCheck, setBankAccountCheck] = useState<boolean>(false)
  const [bankOwnerCheck, setBankOwnerCheck] = useState<boolean>(false)
  const [walletAddressCheck, setWalletAddressCheck] = useState<boolean>(false)
  const [walletNameCheck, setWalletNameCheck] = useState<boolean>(false)
  const [pnCheck, setPnCheck] = useState<boolean>(false)
  const [zipcodeCheck, setZipcodeCheck] = useState<boolean>(false)
  const [addressCheck, setAddressCheck] = useState<boolean>(false)
  const [addressDetailCheck, setAddressDetailCheck] = useState<boolean>(false)

  const validate = () => {
    setNameCheck(validateInput({ type: 'name', data: name })) // 이름 체크
    setBirthdayCheck(validateInput({ type: 'birthDay', data: birthday })) // 생년월일 체크
    setNickCheck(validateInput({ type: 'nickName', data: nickname })) // 닉네임 체크
    setBankAccountCheck(validateInput({ type: 'backAccount', data: account })) // 계좌번호 체크
    setBankOwnerCheck(validateInput({ type: 'backOwner', data: bankOwner })) // 예금주명 체크
    setPnCheck(validateInput({ type: 'phoneNumber', data: receiptPhoneNumber })) // 핸드폰 번호 체크
    setWalletAddressCheck(validateInput({ type: 'walletAddress', data: walletAddress })) // 블록체인 지갑주소 체크
    setWalletNameCheck(validateInput({ type: 'walletName', data: walletName })) // 블록체인 지갑명 체크
    setZipcodeCheck(validateInput({ type: 'zipcode', data: zipcode })) // 우편번호
    setAddressCheck(validateInput({ type: 'address', data: address })) // 주소
    setAddressDetailCheck(validateInput({ type: 'addressDetail', data: addressDetail })) // 상세주소

    if (
      name?.length > 0 &&
      birthday?.length > 0 &&
      nickname?.length > 0 &&
      zipcode?.length > 0 &&
      address?.length > 0 &&
      addressDetail?.length > 0 &&
      walletAddress?.length > 0 &&
      walletName?.length > 0 &&
      account?.length > 0 &&
      bankName?.length > 0 &&
      bankOwner?.length > 0 &&
      checkedTerms.termsService === true &&
      checkedTerms.termsCredit === true &&
      nameCheck === false &&
      bankAccountCheck === false &&
      birthdayCheck === false &&
      bankOwnerCheck === false &&
      nickCheck === false &&
      // pnCheck === false &&
      walletAddressCheck === false &&
      walletNameCheck === false &&
      zipcodeCheck === false &&
      addressCheck === false &&
      addressDetailCheck === false
    ) {
      setValidateStatus(VALIDATE_STATUS.OKAY)
    } else {
      setValidateStatus(VALIDATE_STATUS.INPUT)
    }
  }

  useEffect(() => {
    validate()
  }, [
    name,
    birthday,
    nickname,
    zipcode,
    address,
    addressDetail,
    walletAddress,
    walletName,
    account,
    bankName,
    bankOwner,
    checkedTerms,
    receiptPhoneNumber,
    walletAddressCheck,
    walletNameCheck,
    nameCheck,
    birthdayCheck,
    nickCheck,
    bankAccountCheck,
    bankOwner,
    pnCheck,
    addressCheck,
  ])

  /* wallet 주소 검증 */
  const onVerifyAddress = () => {
    window.open(`https://baobab.scope.klaytn.com/account/${walletAddress}`, '_blank')
  }

  const onSignOut = () => {
    presentAlert({
      mode: 'md',
      header: '정말 로그아웃하시겠습니까?',
      cssClass: 'custom-alert-alert ',
      buttons: [
        {
          text: '아니요',
          cssClass: 'alert-button-cancel',
        },
        {
          text: '네',
          cssClass: 'alert-button-confirm',
          handler: async () => {
            const result = await authStore.signOut()
            if (result === 200) {
              history.push('/home')
              location.reload()
            } else {
              presentToast({
                message: '로그아웃에 실패했습니다!',
                duration: 3000,
                position: 'top',
                color: 'danger',
                icon: warning,
              })
            }
          },
        },
      ],
    })
  }

  const onSignUp = async () => {
    try {
      presentLoading({
        message: '회원 정보입력 중입니다...',
      })
      const momentBirthday = moment(birthday).tz('Asia/Seoul').utc()
      const result = await authStore.signUp({
        name: name,
        nickname: nickname,
        birthday: momentBirthday.format(),
        address: address,
        zipcode: zipcode,
        addressDetail: addressDetail,
        withdrawalAccount: {
          bankName: bankName,
          bankOwner: bankOwner,
          account: account,
          isActive: true,
        },
        wallet: {
          name: walletName,
          address: walletAddress,
          isActive: true,
        },
        extraData: {
          termsService: checkedTerms.termsService,
          termsCredit: checkedTerms.termsCredit,
          termsMarketing: checkedTerms.termsMarketing ? checkedTerms.termsMarketing : undefined,
          receiptPhoneNumber: receiptPhoneNumber ? receiptPhoneNumber : undefined,
        },
      })
      if (result) {
        dismissLoading()
        presentToast({
          message: '회원가입이 완료되었습니다.',
          duration: 3000,
          position: 'top',
          color: 'primary',
          icon: checkbox,
        })
        history.push('/home')
      } else {
        dismissLoading()
        presentToast({
          message: '회원가입에 실패하였습니다.',
          duration: 3000,
          position: 'top',
          color: 'danger',
          icon: checkbox,
        })
      }
    } catch (err: unknown) {
      console.error(err)
    }
  }

  const openPicker = async () => {
    present({
      columns: [
        {
          name: 'bankName',
          options: [
            {
              text: 'NH농협',
              value: 'NH농협',
            },
            {
              text: '신한은행',
              value: '신한은행',
            },
            {
              text: '우리은행',
              value: '우리은행',
            },
            {
              text: '국민은행',
              value: '국민은행',
            },
          ],
        },
      ],
      buttons: [
        {
          text: 'Done',
          handler: (value) => {
            setBankName(value.bankName.value)
          },
        },
      ],
    })
  }

  return (
    <IonPage>
      <StyleIonHeader type="SUB" title={''} href={'/home'} />
      <IonContent>
        <SectionContainer>
          <FlexBetween>
            <TextStyle type="b_20" color="primary_dark">
              간단한 추가정보 입력 후<br></br>회원가입이 완료됩니다.
            </TextStyle>
            <IonButton onClick={onSignOut}>로그아웃</IonButton>
          </FlexBetween>
          <CustomSpacer spacing="24px" />
          <InputContainer>
            <TextStyle type="r_13" color="primary_light">
              이름
            </TextStyle>
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'이름을 입력해주세요'}
              onInput={(e: any) => setName(e.target.value)}
              value={name}
            />
            {nameCheck === true && <AlertText>특수문자 및 숫자는 입력하실 수 없습니다.</AlertText>}
            <CustomSpacer spacing="24px" />
            <TextStyle type="r_13" color="primary_light">
              생년월일 (숫자 8자리)
            </TextStyle>
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'생년월일을 입력해주세요 (YYYYMMDD)'}
              onInput={(e: any) => setBirthday(e.target.value)}
              value={birthday}
            />
            {birthdayCheck === true && <AlertText>생년월일은 숫자 8자리를 입력하셔야 합니다.</AlertText>}
          </InputContainer>
        </SectionContainer>
        <DivideLineBold />
        <SectionContainer>
          <InputContainer>
            <TextStyle type="r_13" color="primary_light">
              닉네임
            </TextStyle>
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'닉네임을 입력해주세요'}
              onInput={(e: any) => setNickname(e.target.value)}
              value={nickname}
            />
            {nickCheck === true && <AlertText>특수문자는 입력하실 수 없습니다.</AlertText>}
            <CustomSpacer spacing="24px" />
            <TextStyle type="r_13" color="primary_light">
              자택 주소
            </TextStyle>
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'우편번호를 입력해주세요'}
              onInput={(e: any) => setZipcode(e.target.value)}
              value={zipcode}
            />
            {zipcodeCheck === true && <AlertText>특수문자는 입력하실 수 없습니다.</AlertText>}
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'주소를 입력해주세요'}
              onInput={(e: any) => setAddress(e.target.value)}
              value={address}
            />
            {addressCheck === true && <AlertText>특수문자는 입력하실 수 없습니다.</AlertText>}
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'상세 주소를 입력해주세요'}
              onInput={(e: any) => setAddressDetail(e.target.value)}
              value={addressDetail}
            />
            {addressDetailCheck === true && <AlertText>특수문자는 입력하실 수 없습니다.</AlertText>}
          </InputContainer>
        </SectionContainer>
        <DivideLineBold />
        <SectionContainer>
          <InputContainer>
            <TextStyle type="r_13" color="primary_light">
              블록체인 지갑 주소
            </TextStyle>
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'블록체인 지갑 주소를 입력해주세요.'}
              onInput={(e: any) => setWalletAddress(e.target.value)}
              value={walletAddress}
            />
            <IonButton color={'dark'} onClick={onVerifyAddress}>
              {'확인'}
            </IonButton>
          </InputContainer>
          {walletAddressCheck === true && <AlertText>지갑 주소 형식이 맞지 않습니다.</AlertText>}
          <InputContainer>
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'지갑명을 입력해주세요.'}
              onInput={(e: any) => setWalletName(e.target.value)}
              value={walletName}
            />
            {walletNameCheck === true && <AlertText>특수문자는 입력하실 수 없습니다.</AlertText>}
            <CustomSpacer spacing="24px" />
            <TextStyle type="r_13" color="primary_light">
              예치금 출금계좌
            </TextStyle>
            <CustomSpacer spacing="8px" />
            <ReadonlyContainer onClick={openPicker}>
              <TextStyle type={'r_15'} color={bankName ? 'primary_dark' : 'gray400'}>
                {bankName ? bankName : '은행명을 선택해주세요.'}
              </TextStyle>
            </ReadonlyContainer>
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'계좌번호를 입력해주세요'}
              onInput={(e: any) => setAccount(e.target.value)}
              value={account}
            />
            {bankAccountCheck === true && <AlertText>특수문자와 한글은 입력하실 수 없습니다.</AlertText>}
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'예금주명을 입력해주세요'}
              onInput={(e: any) => setBankOwner(e.target.value)}
              value={bankOwner}
            />
            {bankOwnerCheck === true && <AlertText>특수문자와 숫자는 입력하실 수 없습니다.</AlertText>}
            <CustomSpacer spacing="24px" />
            <TextStyle type="r_13" color="primary_light">
              현금영수증 번호 (선택)
            </TextStyle>
            <IonInput
              mode={'ios'}
              type={'text'}
              placeholder={'핸드폰 번호를 입력해주세요.'}
              onInput={(e: any) => setReceiptPhoneNumber(e.target.value)}
              value={receiptPhoneNumber}
            />
            {pnCheck === true && <AlertText2>형식이 맞지 않습니다.</AlertText2>}
            <CustomSpacer spacing="8px" />
            <TextStyle type="r_13" color="gray400">
              현금영수증 발급을 위한 휴대폰 번호를 입력해주세요.<br></br>
              사업자 번호는 입력 불가합니다.
            </TextStyle>
          </InputContainer>
        </SectionContainer>
        <DivideLineBold />
        <SectionContainer>
          <TermsContainer>
            <div className="left_items">
              <IonCheckbox className={'check_box'} mode="ios" onIonChange={onSelectAll}></IonCheckbox>
              <TextStyle type="r_14" color="primary_dark">
                약관 전체 동의
              </TextStyle>
            </div>
          </TermsContainer>
          <DivideWrap>
            <DivideLine />
          </DivideWrap>
          <TermsContainer>
            <div className="left_items">
              <IonCheckbox
                className={'check_box'}
                mode="ios"
                name="termsService"
                checked={checkedTerms.termsService}
                onIonChange={onCheckChange}
              ></IonCheckbox>
              <TextStyle type="r_14" color="primary_dark">
                (필수) 서비스 이용약관 동의
              </TextStyle>
            </div>
            <div className="right_items">더 보기</div>
          </TermsContainer>
          <CustomSpacer spacing="16px" />
          <TermsContainer>
            <div className="left_items">
              <IonCheckbox
                className={'check_box'}
                mode="ios"
                name="termsCredit"
                checked={checkedTerms.termsCredit}
                onIonChange={onCheckChange}
              />
              <TextStyle type="r_14" color="primary_dark">
                (필수) 개인정보 수집 이용 동의
              </TextStyle>
            </div>
            <div className="right_items">더 보기</div>
          </TermsContainer>
          <CustomSpacer spacing="16px" />
          <TermsContainer>
            <div className="left_items">
              <IonCheckbox
                className={'check_box'}
                mode="ios"
                name="termsMarketing"
                checked={checkedTerms.termsMarketing}
                onIonChange={onCheckChange}
              />
              <TextStyle type="r_14" color="primary_dark">
                (선택) 마케팅 수집 이용 동의
              </TextStyle>
            </div>
            <div className="right_items">더 보기</div>
          </TermsContainer>
        </SectionContainer>

        <CustomSpacer spacing="16px" />
      </IonContent>
      <FooterButtons
        button={{
          color: 'dark',
          text: validateStatus !== VALIDATE_STATUS.OKAY ? '내용을 입력해주세요.' : '회원정보 입력하기',
          disabled: validateStatus !== VALIDATE_STATUS.OKAY ? true : false,
          onClick: () => onSignUp(),
        }}
      />
    </IonPage>
  )
})

const SectionContainer = styled.div`
  padding: 24px 20px;
`

const ReadonlyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15.5px;
  @media (prefers-color-scheme: light) {
    border: solid 1px #e9e9e9 !important;
  }
  @media (prefers-color-scheme: dark) {
    border: solid 1px #30363a !important;
  }
  border-radius: 8px;
  min-height: 56px;
`

const TermsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left_items {
    display: flex;
    align-items: center;
    .check_box {
      width: 22px;
      height: 22px;
      margin-right: 8px;
      --border-radius: 20px;
      --border-width: 3px;
      --border-color-checked: #000000;
      --checkbox-background-checked: #000000;
      --checkmark-width: 3px;
    }
  }
  .right_items {
    color: var(--ion-color-primary_light);
    text-decoration: underline;
    text-underline-position: under;
  }
`

const DivideWrap = styled.div`
  padding: 16px 0;
`

const FlexBetween = styled.div`
  display: flex;
  justify-content: space-between;
`

const InputContainer = styled.div`
  position: relative;
  width: 100%;
  ion-input {
    margin-top: 8px;
    color: var(--ion-color-primary_dark);
    border-radius: 8px;
    --border-radius: 8px;
    --placeholder-color: var(--ion-color-primary_light);
    --padding-top: 16px;
    --padding-bottom: 16px;
    --padding-start: 16px;
    --padding-end: 80px;
    @media (prefers-color-scheme: light) {
      border: solid 1px #e9e9e9 !important;
    }
    @media (prefers-color-scheme: dark) {
      border: solid 1px #30363a !important;
    }
  }
  .has-focus {
    @media (prefers-color-scheme: light) {
      border: solid 1px #1a1f27 !important;
      border-radius: 8px;
    }
    @media (prefers-color-scheme: dark) {
      border: solid 1px #f7f8f9 !important;
      border-radius: 8px;
    }
  }
  ion-button {
    z-index: 2;
    position: absolute;
    font-size: 11px;
    font-weight: 600;
    color: #ffffff;
    bottom: 7px;
    right: 4px;
    float: right;
    padding: 3.5px 8px;
    --border-radius: 4px;
    --padding-top: 8px;
    --padding-bottom: 8px;
    --padding-end: 8px;
    --padding-start: 8px;
  }
`

const AlertText = styled.div`
  color: red;
`
const AlertText2 = styled.div`
  color: blue;
`
